import React from "react";
import "./Office.scss";
import { MdAccessTime, MdLocationOn } from "react-icons/md";
import { FaBuilding } from "react-icons/fa";

const Office = () => {
  const offices = [
    {
      title: "Head Office",
      timing: "9:30 AM – 6:00 PM",
      address:
        "301, Dhun Complex, Nizampura, Near Mahesana Circle, Vadodara, Gujarat - 390002",
      mapLink:
        "https://maps.app.goo.gl/9AZYCTXkMC6oAAYB9",
    },
    {
      title: "Branch Office",
      timing: "10:00 AM – 7:00 PM",
      address:
        "202, Kunal Complex, Nizampura, Opp Passport Office, Near Bank Of Baroda, Vadodara, Gujarat - 390002",
      mapLink:
        "https://maps.app.goo.gl/NojxzG6Wnagzofb49",
    },
  ];

  return (
    <section className="office-section">
      <div className="office-header">
        <h1>Our Office Locations</h1>
        <p>
          Visit us at our conveniently located offices — we’d love to meet you
          in person.
        </p>
      </div>

      <div className="office-grid">
        {offices.map((office, index) => (
          <div className="office-card" key={index}>
            <div className="office-icon">
              <FaBuilding />
            </div>

            <h3>{office.title}</h3>

            <div className="office-info">
              <p className="timing">
                <MdAccessTime /> {office.timing}
              </p>

              <p className="address" title={office.address}>
                <MdLocationOn />
                <span>{office.address}</span>
              </p>
            </div>

            <a
              href={office.mapLink}
              target="_blank"
              rel="noopener noreferrer"
              className="map-btn"
            >
              Get Directions
            </a>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Office;
